var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutHoverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-drawer-logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 24,
    height: 24,
    rx: 4,
    fill: "rgba(34,124,157,0.04)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "logout_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M7.666,26A1.709,1.709,0,0,1,6,24.33V7.666A1.709,1.709,0,0,1,7.666,6h8.082V7.666H7.666V24.33h8.082V26Zm13.5-5.138L19.97,19.664,22.8,16.831H13.082V15.165h9.665l-2.833-2.833,1.194-1.194L26,16.026Z",
    transform: "translate(-3.998 -3.998)",
    fill: "#c4314b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutHoverIcon);
export default __webpack_public_path__ + "static/media/Logout-hover-icon.034c5956977316b07cc0b6bf3e0a160d.svg";
export { ForwardRef as ReactComponent };